export default function(x) {
  return x === null ? NaN : +x;
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-array/src/number.js
// module id = ../../../../d3-array/src/number.js
// module chunks = vendor